<template>
  <button
    type="button"
    class="button"
    :class="{ expanded: expanded }"
    @click="click"
  >
    {{ expanded ? labelLess : labelMore }}
    <font-awesome-icon icon="chevron-down"/>
  </button>
</template>

<style scoped>
  .button {
    box-sizing: border-box;
    padding: 5px;
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    text-align: center;
    background-color: transparent;
    border: none;
    border-radius: 3px;
    transition: background-color 0.2s;
    cursor: pointer;
    z-index: 20;
  }

  .button:hover {
    background-color: #f3f3f3;
  }

  .button > svg {
    margin-left: 5px;
    transition: transform 0.2s;
  }

  .button.expanded > svg {
    transform: rotate(180deg);
  }
</style>

<script>
  export default {
    props: [
      'click',
      'labelLess',
      'labelMore',
      'expanded'
    ]
  }
</script>
